import * as React from 'react'
import TelemetryProvider from './telemetry-provider';
import { Alert, Badge, Button, Drawer, Layout, List, Menu, notification, Result, Space } from 'antd'
import {Route, RouteComponentProps, withRouter} from 'react-router'
import { CalendarOutlined, UserOutlined } from '@ant-design/icons'
import { Icon } from '@iconify/react';

import moment from 'moment'
import 'moment/locale/it'

import './styles/antd-theme.less'
import './styles/custom.less'
import './styles/fonts.css'
import './styles/typography.less'
import logo from './content/Logo_Negativo.svg'

import { IAuthService } from './services/security/AuthService'
import { IAppLayoutService } from './services/shared/AppLayout'
import { IUtilityService } from './services/UtilityService'

import container from './wires/Bootstrapper'
import SERVICE_IDENTIFIER from './wires/Identifiers'

import { AppContext } from './components/AppContext'
import { AppLogin } from './components/AppLogin'
import { AppRoutes } from './components/AppRoutes'
import { AppSidebar } from './components/AppSidebar'
import { PageAccessoCc } from './components/configurazione/PageAccessoCc'
import { PageYapilyConsensi } from './components/configurazione/PageYapilyConsensi'
import { PageYapilyEmbeddedFlow } from './components/configurazione/PageYapilyEmbeddedFlow'
import { PageYapilyLookup } from './components/yapilylookup/PageYapilyLookup'
import {PageImportFEManuali } from './components/raccoltaDati/PageImportFEManuali'
import { PageError } from './components/shared/PageError'
import { ImportFEManuali, Licenze } from './Dispatcher'
import { getAppInsights } from './TelemetryService'
import { PageSupporto } from './components/supporto/PageSupporto';
import { PageYapilyEmbeddedConsensi } from './components/configurazione/PageYapilyEmbeddedConsensi';
import { ISignalRServiceHandler } from './services/shared/SignalRServiceHandler';
import {Property} from "csstype";

const { Header, Content, Footer } = Layout
const { SubMenu } = Menu



moment.locale('it')

export class AppContextModel {
    Anno: number
    StatoOperativo: string
    DataStato: string
}

class AppLayoutState extends AppContextModel {
    Anni: Array<number>
    open: boolean
    mailsended:boolean
}

export class AppLayout extends React.Component<RouteComponentProps<any>, AppLayoutState> {

    authService: IAuthService
    service: IAppLayoutService
    utilityService: IUtilityService
    signalRService: ISignalRServiceHandler

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.APPLAYOUT_SERVICE)
        this.authService = container.get(SERVICE_IDENTIFIER.AUTH_SERVICE)
        this.utilityService = container.get(SERVICE_IDENTIFIER.UTILITY_SERVICE)
        this.signalRService = container.get(SERVICE_IDENTIFIER.SIGNALR); 
        this.state = new AppLayoutState()
    }

    async componentDidMount() {
        if (this.authService.isAuthenticated()) {
            this.loadYears()
            this.loadStatiOperativi(null)
        }

        this.signalRService.AddEventHandlerFor("StateIsChanged",this.loadStatiOperativi)

    }

    componentWillUnmount() {
        this.signalRService.RemoveEventHandlerFor("StateIsChanged", this.loadStatiOperativi)
    }

    onStateIsChanged = (state, data) => {

        this.setState({ ...this.state, StatoOperativo: state, DataStato : data })
    }

    

    logOut = () => {
        this.authService.signOutAndReload()
    }

    loadStatiOperativi = async (stato) => {
        debugger
        let data = await this.utilityService.GetStatoOperativo()
        this.onStateIsChanged(data.Item1, data.Item2);

    }

    ContattaConsulente = async () => {
        let data = await this.utilityService.ContattaConsulente()
        if (data.IsValid)
            this.setState({ ...this.state, mailsended: true })
        else
            notification.info({
                message: "Impossibile contattare il consulente",
                description:
                    'Siamo spiacenti, si è verificato un errore nel contattare il consulente',
                placement: "topRight"
            });
    }


    loadYears = async () => {
        let data = this.utilityService.GetSelectedYear()
        this.setState({ Anno: data })

        let resp = await this.utilityService.GetAvailableYears()
        if (resp.IsValid == true)
            this.setState({ Anni: resp.Anni })
    }

    setYear = (year: number) => {
        this.utilityService.SetSelectedYear(year)
        this.setState({ Anno: year })
    }
     
    renderYearPicker = () => {
        if (!this.state.Anni)
            return

        return (
            <SubMenu
                icon={<CalendarOutlined />}
                title={this.state.Anno}>
                {this.state.Anni.map(year => <Menu.Item key={year} onClick={() => this.setYear(year)}>{year}</Menu.Item>)}
            </SubMenu>
        )
    }

    getBannerType = ():string => {
        switch (this.state.StatoOperativo) {
            case "Startup": {
                return "#089388"
            }
            case "Pericolo": {
                return "#ff9a10"
            }
            case "Emergenza": {
                return "#ea0303"
            }
            case "Stabilita": {
                return "#10a1cc"
            }
            case "Abbondanza": {
                return "#0e9308"
            }
            case "Potere":{
                return "#6932c8"
            }
            default: {
                return "#202c53"
            }
        }
    }

    getMessage = (): string => {
        switch (this.state.StatoOperativo) {
            case "Startup": {
                return "START UP "
            }
            case "Pericolo": {
                return "PERICOLO"
            }
            case "Emergenza": {
                return "EMERGERNZA"
            }
            case "Stabilita": {
                return "STABILITA"
            }
            case "Abbondanza": {
                return "ABBONDANZA"
            }
            case "Potere": {
                return "POTERE"
            }
            default: {
                return "info"
            }
        }
    }

    getDrawerContent = () => {
        switch (this.state.StatoOperativo) {
            case "Startup": {
                return ["C’è qualcuno che si sta occupando dell’area?",
                    "Trova e inserisciti in ogni linea di comunicazione di cui avrai bisogno per poter dare ed ottenere informazioni relative ai tuoi compiti",
                    "Fatti conoscere da ogni persona di cui avrai bisogno per ottenere informazioni e fornire dati",
                    "Scopri dai tuoi responsabili e da ogni cliente cosa è necessario e voluto da ognuno di loro",
                    "Fai, produci e presenta ciò che ognuno di essi vuole e di cui ha bisogno"]
            }
            case "Pericolo": {
                return ["Resoconto azioni non efficienti ",
                    "Risolvi eventuali disaccordi ",
                    "Metti da parte le abitudini o normali routine",
                    "Risolvi la situazione e qualsiasi pericolo essa presenti",
                    "Assegnati una condizione di Pericolo",
                    "Ripristina la tua etica personale",
                    "Riorganizza la tua vita in modo che la situazione pericolosa non ti si ripresenti continuamente",
                    "Formula e adotta una salda linea di condotta che in futuro individui la stessa situazione e impedisca che essa continui a verificarsi",]
            }
            case "Emergenza": {
                return ["Promuovi. Questo vale per un’organizzazione. Per un individuo sarebbe meglio dire: produci ",
                    "Cambia la tua base operativa ",
                    "Economizza",
                    "Preparati a consegnare. medi",
                    "Parte della condizione di Emergenza contiene questa piccola riga: “dovete rafforzare la disciplina” o “dovete rafforzare l’etica”"]
                    
            }
            case "Stabilita": {
                return ["Quando ci si trova in uno stato di Stabilità, il modo per mantenere un incremento è non cambiare nulla ",
                    "L’etica e la disciplina sono miti.Non vengono intraprese troppe azioni severe ",
                    "Quando una statistica migliora esaminatela attentamente, scoprite ciò che l’ha fatta migliorare e poi fatelo, senza smettere di fare ciò che stavate facendo prima",
                    "Ogni volta che una statistica peggiora un poco, scoprite subito perché e ponetevi rimedio", 
                    "Vi dovete destreggiare tra questi due fattori: la statistica migliora, la statistica peggiora. Sistemate la statistica che peggiora e inevitabilmente scoprirete che, nell’area in cui una statistica peggiora, è stato introdotto qualche cambiamento. È stato introdotto qualche cambiamento e sarà meglio che lo togliate immediatamente di mezzo"]
            }
            case "Abbondanza": {
                return ["Economizza.Ora la prima cosa da fare in Abbondanza è economizzare e poi stare molto, molto attento a non comprare niente che costituisca un impegno per il futuro; non comprate niente che costituisca un impegno per il futuro; non assumete nessuno che costituisca un impegno per il futuro – niente di niente.Tutto ciò fa parte dell’economizzare, stringi il freno ",
                    "Paga tutte le fatture.Raccogli tutte le fatture possibili che riesci a scovare in qualunque posto, ogni soldo di cui sei debitore sulla faccia della Terra, e pagale ",
                    "Investi il resto in agevolazioni al servizio; aumenta le possibilità di consegn",
                    "Scopri che cosa ha prodotto la condizione di Abbondanza e rafforzalo"]
            }
            case "Potere": {
                return ["La prima legge di una condizione di Potere è non disconnettere. Non puoi semplicemente negare le tue connessioni; ciò che devi fare è assumerne il possesso e la responsabilità",
                    "La prima cosa che devi fare è preparare un resoconto di tutte le linee. Questo è l’unico modo in cui potrai mai essere in grado di disconnettere. Quindi, la prima cosa da fare in uno stato di Potere è un completo resoconto scritto di tutta la tua funzione",
                    "La responsabilità consiste nel mettere la cosa per iscritto e fare in modo che arrivi nelle mani della persona che se ne occuperà",
                    "Fai tutto quello che è possibile per fare in modo che quella funzione possa essere occupata"]
            }
            default: {
                return ["info"]
            }
        }
    }

    render() {
        debugger
        let appInsights = null;
        return (
            this.authService.isAuthenticated() == false ?
                <Layout className="full-height">
                    <Content>
                        <AppLogin />
                    </Content>
                </Layout>
                :
                <Layout className="full-height">
                    <AppContext.Provider value={this.state}>
                        
                        <Header>
                           <div>
                               <img src={logo} alt=""
                                    className="logo-header"/>
                           </div>
                            <Menu
                                mode="horizontal"
                                style={{ lineHeight: '64px', textAlign: 'right'}}
                                theme="dark">
                                {this.renderYearPicker()}
                                <SubMenu
                                    title={<UserOutlined />}>
                                    <Menu.Item key="log" onClick={() => this.logOut()}>Logout</Menu.Item>
                                </SubMenu>
                            </Menu>
                        </Header>
                        <Layout>
                            <AppSidebar />    
                            <Layout style={{ padding: '24px' }}>
                                {/*{this.state.DataStato != undefined && (<Alert type={this.getBannerType()} message={this.getMessage()} banner/>)}*/}
                                
                                {this.state.StatoOperativo!=""
                                    ? <div >
                                        <div className="stato-operativo" style={{backgroundColor:this.getBannerType()}} >Il tuo stato operativo è
                                            <b style={{fontSize:'20px'}} > { this.getMessage()} </b>
                                        </div>
                                        <div onClick={()=>this.setState({...this.state, open:true}) }
                                             className="visualizza-suggerimenti"><span>VISUALIZZA I SUGGERIMENTI  <Icon icon="feather:arrow-right-circle" /></span></div> 
                                    </div>
                                    : <></>
                                }


                                
                                <Content
                                    style={{
                                        backgroundColor: this.props.location.pathname == "/Dashboard" || this.props.location.pathname == "/Home"  ? 'rgba(0,0,0,0)' : '#fff',
                                        padding: 24,
                                        margin: 0,
                                        minHeight: 'auto'
                                    }}>
                                    <TelemetryProvider after={() => { appInsights = getAppInsights() }}>
                                        <AppRoutes />
                                        <Route path="/Configurazione/CallBackYapily" component={() => <PageAccessoCc />} />
                                        <Route path="/Configurazione/Consensi/:id" component={() => <PageYapilyConsensi />} />
                                        <Route path="/Configurazione/ConsensiEmbedded/:id" component={() => <PageYapilyEmbeddedConsensi />} />
                                        <Route path="/Configurazione/YapilyWizard/:id" component={() => <PageYapilyEmbeddedFlow />} />
                                        <Route path="/ImportFEManuali" component={() => <ImportFEManuali />} />
                                        <Route path="/Configurazione/Error" component={() => <PageError />} />
                                        <Route path="/Licenze" component={() => <Licenze/>} />
                                    </TelemetryProvider>
                                    
                                </Content>

                                <Drawer title="SUGGERIMENTI" placement="right" visible={this.state.open} width="726px"
                                    onClose={() => this.setState({ ...this.state, open: false })}
                                    >
                                    {!this.state.mailsended ?
                                        <>
                                            <List
                                                bordered
                                                dataSource={this.getDrawerContent()}
                                                renderItem={item => (
                                                    <List.Item>
                                                        <p>{item}</p>
                                                    </List.Item>
                                                )}></List>
                                            <br />
                                            <br />
                                            <Space>
                                                <Button type="primary" onClick={this.ContattaConsulente}>
                                                    CONTATTA IL CONSULENTE
                                                </Button>
                                            </Space>
                                        </>
                                        :
                                        <Result
                                            status="success"
                                            title="Mail inviata correttamente!"
                                            subTitle="La richiesta di contatto è stata correttamente inviata al tuo consulente che ti contatterà nei prossimi giorni"
                                        />}
                                </Drawer>
                                <Footer />
                            </Layout>
                        </Layout>
                    </AppContext.Provider>
                </Layout>
        )
    }
}

export default withRouter(AppLayout)